import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import certificate from '../Assets/Certificate.jpg'
import Tilt from 'react-parallax-tilt';

const Recog = () => {
  const containerRef = useRef(null);
  const entriesRef = useRef([]);

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: containerRef.current,
        start: 'top 80%', // Adjust as needed
        toggleActions: 'play none none reverse',
      },
    });

    tl.from(containerRef.current, { opacity: 0, y: 50, duration: 1, ease: 'power2.out' });

    entriesRef.current.forEach((entry, index) => {
      tl.fromTo(
        entry,
        { scale: 0.8, opacity: 0 },
        { scale: 1, opacity: 1, duration: 0.6, delay: index * 0.2, ease: 'power1.out' },
        '-=0.4' // Overlap animations slightly
      );
    });
  }, []);

  return (
    <div ref={containerRef} className="sm:px-8 my-20 text-white">
     
      <h1 className='text-[7.5vw] lg:text-5xl font-bold mb-16 text-[#FFDC00] relative'> Recognition
      <span className='absolute -bottom-4 left-0 w-full h-0.5 bg-gradient-to-r from-[#FFDC00] to-transparent '></span>
      </h1>

    <Tilt className='w-fit m-auto '>
    <img src={certificate} className='sm:w-[50vw]  rounded-xl' alt="" />
    </Tilt>

    <div className='my-10 flex flex-col gap-7 text-gray-300'>
      <h1 className='font-semibold sm:text-[2vw] tracking-[2px] text-white'>Full Stack Web Development Certification</h1>
      <p>Issued by : <span className='text-[#FFDC00]'>udemy</span></p>
    
        <p>Date : <span className='text-[#FFDC00]'>29 Jan, 2025</span></p>
      

      <div className='flex sm:flex-row flex-col  gap-4 sm:items-center'>
      Skills Gained :
      <p className='bg-[#FFDC00] px-5 py-2 sm:text-start text-center text-black rounded-full'>React</p>
      <p className='bg-[#FFDC00] px-5 py-2 sm:text-start text-center text-black rounded-full'>Nodejs</p>
      <p className='bg-[#FFDC00] px-5 py-2 sm:text-start text-center text-black rounded-full'>Express</p>
      <p className='bg-[#FFDC00] px-5 py-2 sm:text-start text-center text-black rounded-full'>MongoDB</p>
      </div>



      <p className='sm:leading-[30px] leading-[25px] text-sm sm:text-lg'>This certification has equipped me with the skills to build scalable, user-friendly web applications from scratch. It reflects my commitment to continuous learning and professional growth in the field of web development.</p>

    </div>
     
   
    </div>
  );
};

export default Recog;